import { Config } from '@/environment';

import {
  RewardsBanner,
  LoyaltyInterruptModal,
  UpsellItem,
  GuacMode,
  SystemFlags,
  CreateAccountSignInContentFragment,
  AccountModalContentFragment,
  FacModalContent,
  NutritionFactsContentFragment,
  TaxContent,
  BagContent,
  AccountOptInToolTipsContentFragment,
  OrderReviewModalContentFragment,
  OrderConfirmationCreateAccountExperience,
  CyobRewardContentFragment,
  LegalCopy,
  ReferAFriendFooterContentFragment,
  ReferAFriendModalContentFragment,
  ReferralJoinSuccessContentFragment,
  ReferralNotEligibleContentFragment,
  AlreadyAMemberModalContentFragment,
  YoureInvitedModalContentFragment,
  ReferAFriendLinkOpenedContentFragment,
  SummerOfExtrasIntroScreensContentFragment,
  ScanlessIntroductionContentFragment,
  ScanlessCreditCardAlreadyAssociatedContentFragment,
  ChipotleuReVerificationContentFragment,
  ChipotleuReVerificationSuccessModalContentFragment,
  EmployeeRewardsHowItWorksModalContentFragment
} from '@/models/cms';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { SubmitOrderRequestPaymentMethod, SubmitOrderRequestPaymentMethodType } from '@/models/order';
import { getCountryCodeByTopLevelDomain, isLocal } from '@/helpers';
import { CountryCode } from '@/store/ui';
import { ApiService } from '../api/api.service';
import { Logger } from '../logger';
import axios, { AxiosInstance } from 'axios';
import { AnalyticsService } from '../analytics/analytics.service';
import { getCountryByHostname } from '@/helpers/country';

export interface ConfigService {
  isLocal(): boolean;
  getBuyGiftCardsUrl(): string;
  getSupportUrl(): string;
  getCateringUrl(): string;
  getRewardsTermsUrl(): string;
  getFaqUrl(): string;
  getRecaptchaKey(): string;
  getBuild(): string;
  getHomePagePromoBannerCanada(): RewardsBanner;
  getHomePageRewardsBanner(): RewardsBanner;
  getRewardsPageGuacModeRewardsBanner(): RewardsBanner;
  getRewardsPageGuestUnenrolledRewardsBanner(): RewardsBanner;
  getLoyaltyInterruptModal(): LoyaltyInterruptModal | undefined;
  setLoyaltyInterruptModal(): void;
  getUpsellItems(): UpsellItem[];
  setUpsellItems(): void;
  getLegalText(): LegalCopy;
  setLegalText(country?: string | null): Promise<void>;
  getJoinRewards(): string | undefined;
  setJoinRewards(): void;
  getPickupOptions(): any[];
  setPickupOptions(): void;
  getSignInModal(): CreateAccountSignInContentFragment;
  setSignInModal(): Promise<void>;
  getCreateAccountModal(): CreateAccountSignInContentFragment;
  setCreateAccountModal(): void;
  getAccountOptInToolTips(): AccountOptInToolTipsContentFragment;
  setAccountOptInToolTips(): void;
  getFacModalContent(): FacModalContent | undefined;
  setFacModalContent(): void;
  getBagContent(): BagContent | undefined;
  setBagContent(): void;
  getNutritionFacts(): NutritionFactsContentFragment | undefined;
  setNutritionFacts(): void;
  getAccountModal(): AccountModalContentFragment;
  setAccountModal(): void;
  getTaxContent(): TaxContent | undefined;
  setTaxContent(): void;
  getGuestOrderConfirmation(): OrderConfirmationCreateAccountExperience | null
  setGuestOrderConfirmation(): void
  getOrderReviewModal(): OrderReviewModalContentFragment | undefined
  setOrderReviewModal(): void
  getCyobRewardCard(): CyobRewardContentFragment | undefined
  setCyobRewardCard(): void
  getReferAFriendFooter(): ReferAFriendFooterContentFragment | undefined;
  setReferAFriendFooter(): void;
  getReferAFriendModal(): ReferAFriendModalContentFragment | undefined;
  setReferAFriendModal(): void;
  getAlreadyAMemberModal(): AlreadyAMemberModalContentFragment;
  setAlreadyAMemberModal(): void;
  getYoureInvitedModal(): YoureInvitedModalContentFragment;
  setYoureInvitedModal(): void;
  getReferralJoinSuccessModal(): ReferralJoinSuccessContentFragment | undefined;
  setReferralJoinSuccessModal(): void;
  getReferralNotEligibleModal(): ReferralNotEligibleContentFragment | undefined;
  setReferralNotEligibleModal(): void;
  getReferAFriendLinkOpened(): ReferAFriendLinkOpenedContentFragment | undefined;
  setReferAFriendLinkOpened(): void;
  getEnergyUnitByCountry(): string;
  getSystemFlags(): SystemFlags;
  getHeaderPages(): string[];
  getGuacMode(): GuacMode | null;
  getPayeezyJsUrl(): string;
  getChaseJsUrl(): string;
  getChaseBaseUrl(): string;
  getChaseUkBaseUrl(): string;
  getChaseUkRedirectUrl(): string;
  getUComIsDebugConfiguration(): boolean;
  getAmeliaPepperCssUrl(): string;
  getAmeliaPepperJsUrl(): string;
  getTwitterAchievementBaseUrl(): string;
  getAllergenStatementUrl(): string;
  getSessionFrameUrl(): string;
  getRealFoodprintUrl(): string;
  getHowGoodUrl(): string;
  getRewardsPath(): string;
  getRefreshPointsThrottleTimeInMinutes(): number;
  getIsStubPayment(): boolean;
  getStubPayment(): SubmitOrderRequestPaymentMethod;
  showRestaurantsWithNoAddress(): boolean;
  getApplePayMerchantId(): string;
  getGooglePayMerchantGatewayId(): string;
  getGooglePayMerchantGateway(): string;
  getGooglePayMerchantId(): string;
  getGooglePayEnvironment(): google.payments.api.Environment;
  getOptinProgramLaunchDate(): Date;
  getIdMeClientId(): string;
  getIdMeRedirectUrl(): string;
  getIdMeWidgetScriptUrl(): string;
  getSummerOfExtrasIntroScreens(): SummerOfExtrasIntroScreensContentFragment | undefined;
  setSummerOfExtrasIntroScreens(): void;
  getScanlessIntroductionModal(): ScanlessIntroductionContentFragment;
  setScanlessIntroductionModal(): Promise<void>;
  getScanlessInfoIconModal(): ScanlessIntroductionContentFragment;
  setScanlessInfoIconModal(): Promise<void>;
  getScanlessCreditCardAlreadyAssociated(): ScanlessCreditCardAlreadyAssociatedContentFragment | undefined;
  setScanlessCreditCardAlreadyAssociated(): Promise<void>;
  getChipotleuReVerification(): ChipotleuReVerificationContentFragment;
  setChipotleuReVerification(): void;
  getChipotleuReVerificationSuccessModal(): ChipotleuReVerificationSuccessModalContentFragment | undefined;
  setChipotleuReVerificationSuccessModal(): void;
  getEmployeeRewardsHowItWorksModal(): EmployeeRewardsHowItWorksModalContentFragment | undefined;
  setEmployeeRewardsHowItWorksModal(): void;
}

export class AppConfigService extends ApiService implements ConfigService {
  constructor(private config: Config, protected store: Store<AppState>, httpClient: AxiosInstance, logger: Logger, protected analytics: AnalyticsService) {
    super(store, httpClient, logger, analytics);
  }

  isLocal(): boolean {
    return this.config.isLocal;
  }

  isCanada(): boolean {
    return getCountryCodeByTopLevelDomain() == CountryCode.CA;
  }

  getBuyGiftCardsUrl(): string {
    return this.config.urls.buyGiftCards;
  }

  getSupportUrl(): string {
    return this.config.urls.support;
  }

  getCateringUrl(): string {
    return this.config.urls.catering;
  }

  getRewardsTermsUrl(): string {
    return this.config.urls.rewardsTerms;
  }

  getFaqUrl(): string {
    return this.config.urls.faq;
  }

  getRecaptchaKey(): string {
    return this.config.recaptcha.key;
  }

  getBuild(): string {
    return this.config.build;
  }

  getHomePagePromoBannerCanada(): RewardsBanner {
    return this.config.cms.homePagePromoBannerCanada;
  }

  getHomePageRewardsBanner(): RewardsBanner {
    return this.config.cms.homePageRewardsBanner;
  }

  getRewardsPageGuacModeRewardsBanner(): RewardsBanner {
    return this.config.cms.rewardsPageGuacModeRewardsBanner;
  }

  getRewardsPageGuestUnenrolledRewardsBanner(): RewardsBanner {
    return this.config.cms.rewardsPageGuestUnenrolledRewardsBanner;
  }

  getLoyaltyInterruptModal(): LoyaltyInterruptModal | undefined {
    return this.config.cms.loyaltyInterruptModal;
  }

  async setLoyaltyInterruptModal() {
    const cfData = await this.getGraphqlContentFragment('loyalty-interrupt-modal');

    if (cfData.loyaltyInterruptModal && cfData.loyaltyInterruptModalList.items[0]) {
      let csLoyaltyInterruptModal = cfData.loyaltyInterruptModalList.items[0];
      this.config.cms.loyaltyInterruptModal = {
        subCopy: csLoyaltyInterruptModal.subText,
        salutation: csLoyaltyInterruptModal.salutation,
        howRewardsWorksCta: csLoyaltyInterruptModal.howRewardsWorksCta,
        medallionImageUrl: csLoyaltyInterruptModal.medallionImageUrl?._path,
        mainCopy: csLoyaltyInterruptModal.mainText,
        joinNowCta: csLoyaltyInterruptModal.joinNowCta,
      };
    }
    else {
      this.logger.error(`Missing content fragment: loyalty-interrupt-modal`);

      this.config.cms.loyaltyInterruptModal = {
        subCopy: `With Chipotle Rewards, you'll earn points to score FREE Chipotle.`,
        salutation: 'Welcome,',
        howRewardsWorksCta: 'HOW REWARDS WORKS',
        medallionImageUrl: `/content/dam/chipotle/icons-and-animations/chipotle-pepper-icon/pepper-medallion.svg`,
        mainCopy: 'REWARD YOURSELF WITH FREE CHIPOTLE',
        joinNowCta: 'JOIN NOW',
      };
    }
  }

  getUpsellItems(): UpsellItem[] {
    return this.config.cms.upsellItems ?? [];
  }

  async setUpsellItems() {
    const cfData = await this.getGraphqlContentFragment('upsell');

    if (cfData && cfData.upsellList && cfData.upsellList.items) {
      this.config.cms.upsellItems = cfData.upsellList.items.map((item: any) => {
        item.imageUrl = `${item.imageUrl?._path}`;
        item.shortName = item.MenuItemName;
        return item;
      });
    }
    else {
      this.logger.error(`Missing content fragment: upsell`);

      this.config.cms.upsellItems = [];
    }
  }

  getLegalText(): LegalCopy {
    const country = this.store.state.ui.countryProfile.countryCode;
    if(this.config.cms.legalCopy){
      return this.config.cms.legalCopy;
    }
    if(country === CountryCode.CA) {
      return {
          createAnAccount: "<p data-renderer-start-pos=\"923\">By creating an account, I agree to&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy\" href=\"https://www.chipotle.ca/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a>, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/terms-of-use\" href=\"https://www.chipotle.ca/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>, and if you are a member of our Rewards program, the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/rewards-terms\" href=\"https://www.chipotle.ca/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply. I further agree that by creating an account the information I provide, including my personal information, will be used to create and administer my account and as otherwise provided in <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy\" href=\"https://www.chipotle.ca/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a> (including the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy#financial-incentives\" href=\"https://www.chipotle.ca/privacy-policy#financial-incentives\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Notice of Financial Incentives</a>), <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/rewards-terms\" href=\"https://www.chipotle.ca/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a> and, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/terms-of-use\" href=\"https://www.chipotle.ca/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>.</p><p data-renderer-start-pos=\"1006\">*By enrolling in Chipotle Rewards, you confirm you are a resident of Canada (excluding Quebec), at least 16 years old, have parent/legal guardian consent if you are not age of majority, and you agree to&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/about-us/privacy-notice\" href=\"https://www.chipotle.ca/about-us/privacy-notice\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Chipotle’s Privacy Policy</u></a>&nbsp;and&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/about-us/rewards-terms\" href=\"https://www.chipotle.ca/about-us/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Chipotle Rewards Terms and Conditions</u></a>.&nbsp;</p><p data-renderer-start-pos=\"1280\">**By selecting “yes”, you agree to receive email messages about Chipotle offers and promotions. You can unsubscribe at any time. Your consent is not required to make a purchase or enroll in Chipotle Rewards. To unsubscribe from emails, use the link in each email or visit Personal &amp; Preferences in the Account section and deselect your email subscription.</p><p data-renderer-start-pos=\"1637\">If you sign up for SMS offers and promotions, you acknowledge that Chipotle Mexican Grill Canada Corp or its designated agent may send you commercial text messages using an auto-dialer or other technology. You consent to that type of contact. Standard message and data rates may apply. You can opt out at any time. You are not required to agree to this as a condition of Purchasing any property, goods, or services. Text HELP for help. Text STOP to cancel. Visit the Mobile Terms &amp; Conditions section of our Terms of Use to learn more.</p><p data-renderer-start-pos=\"2174\">Chipotle Mexican Grill Canada Corp., 900-1959 Upper Water St., Halifax NS B3J 2X2 Canada, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca\" href=\"https://www.chipotle.ca/\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">www.chipotle.ca</a>&nbsp;</p>\n",
          createAnAccountOrderConfirmation: "<p data-renderer-start-pos=\"923\">By creating an account, I agree to&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy\" href=\"https://www.chipotle.ca/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a>, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/terms-of-use\" href=\"https://www.chipotle.ca/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>, and if you are a member of our Rewards program, the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/rewards-terms\" href=\"https://www.chipotle.ca/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply. I further agree that by creating an account the information I provide, including my personal information, will be used to create and administer my account and as otherwise provided in <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy\" href=\"https://www.chipotle.ca/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a> (including the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/privacy-policy#financial-incentives\" href=\"https://www.chipotle.ca/privacy-policy#financial-incentives\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Notice of Financial Incentives</a>), <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/rewards-terms\" href=\"https://www.chipotle.ca/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a> and, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/terms-of-use\" href=\"https://www.chipotle.ca/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>.</p><p data-renderer-start-pos=\"1006\">*By enrolling in Chipotle Rewards, you confirm you are a resident of Canada (excluding Quebec), at least 16 years old, have parent/legal guardian consent if you are not age of majority, and you agree to&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/about-us/privacy-notice\" href=\"https://www.chipotle.ca/about-us/privacy-notice\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Chipotle’s Privacy Policy</u></a>&nbsp;and&nbsp;<a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca/about-us/rewards-terms\" href=\"https://www.chipotle.ca/about-us/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Chipotle Rewards Terms and Conditions</u></a>.&nbsp;</p><p data-renderer-start-pos=\"1280\">**By selecting “yes”, you agree to receive email messages about Chipotle offers and promotions. You can unsubscribe at any time. Your consent is not required to make a purchase or enroll in Chipotle Rewards. To unsubscribe from emails, use the link in each email or visit Personal &amp; Preferences in the Account section and deselect your email subscription.</p><p data-renderer-start-pos=\"1637\">If you sign up for SMS offers and promotions, you acknowledge that Chipotle Mexican Grill Canada Corp or its designated agent may send you commercial text messages using an auto-dialer or other technology. You consent to that type of contact. Standard message and data rates may apply. You can opt out at any time. You are not required to agree to this as a condition of Purchasing any property, goods, or services. Text HELP for help. Text STOP to cancel. Visit the Mobile Terms &amp; Conditions section of our Terms of Use to learn more.</p><p data-renderer-start-pos=\"2174\">Chipotle Mexican Grill Canada Corp., 900-1959 Upper Water St., Halifax NS B3J 2X2 Canada, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.ca\" href=\"https://www.chipotle.ca/\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">www.chipotle.ca</a>&nbsp;</p>\n",
          createAnAccount2sv: "<p>Message and data rates may apply.</p>\n",
          signIn: "<p>By signing in, I agree to <a href=\"https://www.chipotle.ca/privacy-policy\" title=\"https://www.chipotle.ca/privacy-policy\">Chipotle's Privacy Policy</a>, <a href=\"https://www.chipotle.ca/terms-of-use\" title=\"https://www.chipotle.ca/terms-of-use\">Terms of Use</a>, and if you are a member of our Rewards program, the <a href=\"https://www.chipotle.ca/rewards-terms\" title=\"https://www.chipotle.ca/rewards-terms\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply.</p>\n",
          updateProfile: "<p>By updating your account, you authorize Chipotle to send a text to the phone number selected with a verification code. Msg &amp; Data rates may apply.</p>\n",
          personalAndPreference: "<p>By enrolling in Chipotle Rewards and/or participating in the program, you confirm you are a resident of Canada (excluding Quebec), at least 16 years old, have parent/legal guardian consent if you are not age of majority, and you agree to&nbsp;<a href=\"https://www.chipotle.ca/about-us/privacy-notice\">Chipotle’s Privacy Policy</a>&nbsp;and&nbsp;<a href=\"https://www.chipotle.ca/about-us/rewards-terms\">Chipotle Rewards Terms and Conditions</a>.&nbsp;</p>\n<p>By electing to receive email updates, you agree to receive email messages about Chipotle offers and promotions. You can unsubscribe at any time. Your consent is not required to make a purchase or enroll in Chipotle Rewards. To unsubscribe from emails, use the link in each email or visit Personal &amp; Preferences in the Account section and deselect your email subscription.</p>\n<p>If you elect to receive texts, you will receive recurring automated marketing messages to your mobile number. Standard message and data rates may apply. Text STOP or visit Personal &amp; Preferences in the Account section and deselect your text subscription to unsubscribe from texts. Text HELP for help.</p>\n<p>Chipotle Mexican Grill Canada Corp., 900-1959 Upper Water St., Halifax NS B3J 2X2 Canada,&nbsp;<a href=\"http://www.chipotle.ca\">www.chipotle.ca</a><a>&nbsp;</a></p>\n",
          loggedInUnEnrolled: "<p>By enrolling in Chipotle Rewards, you confirm you are a resident of Canada (excluding Quebec), at least 16 years old, have parent/legal guardian consent if you are not age of majority, and you agree to&nbsp;<a href=\"https://www.chipotle.ca/about-us/privacy-notice\">Chipotle’s Privacy Policy</a>&nbsp;and&nbsp;<a href=\"https://www.chipotle.ca/about-us/rewards-terms\">Chipotle Rewards Terms and Conditions</a>.&nbsp;</p>\n",
          retroCredit: "<p>We do not accept credit requests for app or online purchases at this time. You will have up to 30 days after the purchase to receive credit. If your request is approved, your points will show up in your account in 24-48 hours. If your points do not show up after 48 hours, we may not have been able to grant your request. View our Terms &amp; Conditions for a list of reasons why a request may not be granted. You can always contact customer service for help.&nbsp;</p>\n",
          nutritionCalculatorBuilderDisclaimer: "<p>2,000 calories a day is used for general nutrition advice, but calorie needs vary. Nutritional content may vary because of variations in portion size or recipes, changes in growing seasons, or differences in the sources of our ingredients. We may update this chart from time to time.</p>\n",
          chooseYourOwnBirthday: ""
      }
    }
    if(country === CountryCode.UK) {
      return {
        createAnAccount: "<p>By creating an account, you assert you are at least 16 years of age and you agree to Chipotle’s <a href=\"https://www.chipotle.co.uk/privacy-notice\">Privacy Policy</a> and <a href=\"https://www.chipotle.co.uk/terms-of-use\">Terms of Use</a>.<br>\n<br>\nBy selecting “Yes”, you agree to receive email messages about Chipotle offers and promotions. You can unsubscribe at any time. Your consent is not required to make a purchase. To unsubscribe from emails, use the link in each email or visit Personal &amp; Preferences in the Account section and deselect your email subscription.<br>\n<br>\nIf you elect to receive texts, you will receive recurring automated marketing messages to your mobile number. Standard message and data rates may apply. Text STOP or visit Personal &amp; Preferences in the Account section and deselect your text subscription to unsubscribe from texts. Text HELP for help.</p>\n",
        createAnAccountOrderConfirmation: "<p>By creating an account, you assert you are at least 16 years of age and you agree to Chipotle’s&nbsp;<a href=\"https://www.chipotle.co.uk/privacy-notice\">Privacy Policy</a>&nbsp;and&nbsp;<a href=\"https://www.chipotle.co.uk/terms-of-use\">Terms of Use</a>.</p>\n<p>By selecting “Yes”, you agree to receive email messages about Chipotle offers and promotions. You can unsubscribe at any time. Your consent is not required to make a purchase. To unsubscribe from emails, use the link in each email or visit Personal &amp; Preferences in the Account section and deselect your email subscription.</p>\n<p>If you elect to receive texts, you will receive recurring automated marketing messages to your mobile number. Standard message and data rates may apply. Text STOP or visit Personal &amp; Preferences in the Account section and deselect your text subscription to unsubscribe from texts. Text HELP for help.</p>\n",
        createAnAccount2sv: "<p>Message and data rates may apply.</p>\n",
        signIn: "",
        updateProfile: "",
        personalAndPreference: "<p>Toggle the buttons above in order to receive marketing and other communications (which may include exclusive offers, promotions and discount codes) from Chipotle (or service providers acting on Chipotle’s behalf). You may unsubscribe at any time. Chipotle's website and communications are subject to our <a href=\"https://www.chipotle.co.uk/privacy-notice\">Privacy Policy</a> and <a href=\"https://www.chipotle.co.uk/terms-of-use\">Terms of Use</a>.</p>\n",
        loggedInUnEnrolled: "<p>By joining, I am confirming I am 13 years of age or older, will be enrolled in Chipotle Rewards, will receive email updates, promotions and offers from Chipotle, and agree to&nbsp;<a title=\"Privacy Policy\" href=\"https://www.chipotle.co.uk/about-us/privacy-policy\">Chipotle’s&nbsp;<u>Privacy Policy</u></a>&nbsp;and&nbsp;<u><a title=\"Terms And Conditions\" href=\"https://www.chipotle.co.uk/about-us/rewards-terms\">Terms &amp; Conditions</a></u>.</p>\n",
        retroCredit: "<p>We do not accept credit requests for app or online purchases at this time. You will have up to 30 days after the purchase to receive credit. If your request is approved, your points will show up in your account in 24-48 hours. If your points do not show up after 48 hours, we may not have been able to grant your request. View our&nbsp;<a href=\"https://www.chipotle.co.uk/about-us/rewards-terms\">Terms And Conditions</a>&nbsp;for a list of reasons why a request may not be granted. You can always&nbsp;<a href=\"https://www.chipotle.co.uk/contact-us#report-an-issue\">Contact Customer Service</a>&nbsp;for help.</p>\n",
        nutritionCalculatorBuilderDisclaimer: "<p>Data is derived by laboratory analysis. Products may be subject to some variation depending on ingredients used, supplier, and seasonality. Because of this, the products used may not be identical to the products served in our restaurants.</p>\n<p>Nutritional data is listed per serving. Adults need around 2000 kcal a day. For all allergen information, please visit <a href=\"/content/chipotle/gb/en/allergens.html\">chipotle.co.uk/allergens</a></p>\n",
        chooseYourOwnBirthday: ""
      }
    }
    //default US
    return {
      createAnAccount: "<p data-renderer-start-pos=\"2511\">By creating an account, I agree to <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy\" href=\"https://www.chipotle.com/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a>, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>, and if you are a member of our Rewards program, the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/rewards-terms\" href=\"https://www.chipotle.com/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply. I further agree that by creating an account the information I provide, including my personal information, will be used to create and administer my account and as otherwise provided in <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy\" href=\"https://www.chipotle.com/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a> (including the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy#financial-incentives\" href=\"https://www.chipotle.com/privacy-policy#financial-incentives\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Notice of Financial Incentives</a>), <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/rewards-terms\" href=\"https://www.chipotle.com/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a> and, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>.</p><p data-renderer-start-pos=\"2856\">*If you sign up for text offers and promotions, you acknowledge that CMG Strategy Co., LLC or its designated agent may send you commercial text messages using an auto-dialer or other technology. You consent to that type of contact. Standard message and data rates may apply. You can opt out at any time. You are not required to agree to this as a condition of purchasing any property, goods, or services. Text HELP for help. Text STOP to cancel. Visit the Mobile Terms &amp; Conditions section of our <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Terms of Use</u></a> to learn more.&nbsp;</p>",
      createAnAccountOrderConfirmation: "<p data-renderer-start-pos=\"2511\">By creating an account, I agree to <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy\" href=\"https://www.chipotle.com/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a>, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>, and if you are a member of our Rewards program, the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/rewards-terms\" href=\"https://www.chipotle.com/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply. I further agree that by creating an account the information I provide, including my personal information, will be used to create and administer my account and as otherwise provided in <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy\" href=\"https://www.chipotle.com/privacy-policy\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Chipotle's Privacy Policy</a> (including the <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/privacy-policy#financial-incentives\" href=\"https://www.chipotle.com/privacy-policy#financial-incentives\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Notice of Financial Incentives</a>), <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/rewards-terms\" href=\"https://www.chipotle.com/rewards-terms\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Rewards Terms</a> and, <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\">Terms of Use</a>.</p><p data-renderer-start-pos=\"2856\">*If you sign up for text offers and promotions, you acknowledge that CMG Strategy Co., LLC or its designated agent may send you commercial text messages using an auto-dialer or other technology. You consent to that type of contact. Standard message and data rates may apply. You can opt out at any time. You are not required to agree to this as a condition of purchasing any property, goods, or services. Text HELP for help. Text STOP to cancel. Visit the Mobile Terms &amp; Conditions section of our <a class=\"css-1rn59kg\" title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\" data-testid=\"link-with-safety\" data-renderer-mark=\"true\"><u data-renderer-mark=\"true\">Terms of Use</u></a> to learn more.&nbsp;</p>",
      createAnAccount2sv: "<p>Message and data rates may apply.</p>\n",
      signIn: "<p>By signing in, I agree to <a title=\"https://www.chipotle.com/privacy-policy\" href=\"https://www.chipotle.com/privacy-policy\">Chipotle's Privacy Policy</a>, <a title=\"https://www.chipotle.com/terms-of-use\" href=\"https://www.chipotle.com/terms-of-use\">Terms of Use</a>, and if you are a member of our Rewards program, the <a title=\"https://www.chipotle.com/rewards-terms\" href=\"https://www.chipotle.com/rewards-terms\">Rewards Terms</a>, and to receiving account security/verification text messages from Chipotle. Msg &amp; Data rates may apply.</p>",
      updateProfile: "<p>By updating your account, you authorize Chipotle to send a text to the phone number selected with a verification code. Msg &amp; Data rates may apply.</p>\n",
      personalAndPreference: "<p>By joining Chipotle Rewards, I am confirming I am 13 years of age or older, will receive email updates, promotions and offers from Chipotle, and agree to&nbsp;<u><a title=\"Privacy Policy\" href=\"https://www.chipotle.com/about-us/privacy-policy\">Chipotle's Privacy Policy</a></u>&nbsp;and&nbsp;<u><a title=\"Rewards Terms And Conditions\" href=\"https://www.chipotle.com/about-us/rewards-terms\">Rewards Terms and Conditions</a></u>.</p>\n<p>By opting in to 'Text,' I agree to receive Chipotle updates and offers via text and agree to&nbsp;<u><a title=\"Privacy Policy\" href=\"https://www.chipotle.com/about-us/privacy-policy\">Chipotle's Privacy Policy</a></u>&nbsp;and&nbsp;<u><a title=\"Terms and Conditions\" href=\"https://www.chipotle.com/about-us/rewards-terms\">Terms and Conditions</a></u>.&nbsp;Recurring marketing messages will be sent to your account mobile number using automated technology. Standard msg and data rates may apply. Text STOP to cancel. Text HELP for help. By updating this account, I agree to&nbsp;<u><a title=\"Privacy Policy\" href=\"https://www.chipotle.com/about-us/privacy-policy\">Chipotle's Privacy Policy</a></u>&nbsp;&nbsp;and&nbsp;<u><a title=\"Terms of Use\" href=\"https://www.chipotle.com/about-us/terms-of-use\">Terms of Use</a></u>.&nbsp;</p>\n",
      loggedInUnEnrolled: "<p>By joining, I am confirming I am 13 years of age or older, will be enrolled in Chipotle Rewards, will receive email updates, promotions and offers from Chipotle, and agree to&nbsp;<a title=\"Privacy Policy\" href=\"https://www.chipotle.com/about-us/privacy-policy\">Chipotle’s&nbsp;<u>Privacy Policy</u></a>&nbsp;and&nbsp;<u><a title=\"Terms And Conditions\" href=\"https://www.chipotle.com/about-us/rewards-terms\">Terms &amp; Conditions</a></u>.&nbsp;</p>\n",
      retroCredit: "<p>We do not accept credit requests for app or online purchases at this time. You will have up to 30 days after the purchase to receive credit. If your request is approved, your points will show up in your account in 24-48 hours. If your points do not show up after 48 hours, we may not have been able to grant your request. View our <a href=\"https://www.chipotle.com/about-us/rewards-terms\">Terms And Conditions</a> for a list of reasons why a request may not be granted. You can always <a href=\"https://www.chipotle.com/contact-us#report-an-issue\">Contact Customer Service</a> for help.&nbsp;</p>\n",
      nutritionCalculatorBuilderDisclaimer: "<p>2,000 calories a day is used for general nutrition advice, but calorie needs vary. Nutritional content may vary because of variations in portion size or recipes, changes in growing seasons, or differences in the sources of our ingredients. We may update this chart from time to time.</p>\n",
      chooseYourOwnBirthday: ""
    }
  }

  async setLegalText(country = null) {
    const cfData = await this.getGraphqlContentFragment(country ? `legal-text;region=${country}` : `legal-text;region=${this.getRegion()}`);
    
    if (cfData && cfData.legalTextList && cfData.legalTextList.items[0]) {
      let legalCopy = cfData.legalTextList.items[0];

      this.config.cms.legalCopy = {
        createAnAccount: legalCopy.createAnAccount.html,
        createAnAccountOrderConfirmation: legalCopy.createAnAccountOrderConfirmation.html,
        createAnAccount2sv: legalCopy.createAnAccount2sv.html,
        signIn: legalCopy.signIn.html,
        updateProfile: legalCopy.updateProfile.html,
        personalAndPreference: legalCopy.personalAndPreference.html,
        loggedInUnEnrolled: legalCopy.loggedInUnEnrolled.html,
        retroCredit: legalCopy.retroCredit.html,
        nutritionCalculatorBuilderDisclaimer: legalCopy.nutritionCalculatorBuilderDisclaimer.html,
        chooseYourOwnBirthday: legalCopy.chooseYourOwnBirthday.html
      };
    }
    else {
      this.logger.error(`Missing content fragment: legal-text`);
      this.config.cms.legalCopy = {
        createAnAccount: '',
        createAnAccountOrderConfirmation: '',
        createAnAccount2sv: `<p></p>\n`,
        signIn: `<p></p>\n`,
        updateProfile: `<p></p>\n`,
        personalAndPreference: `<p></p>\n`,
        loggedInUnEnrolled: `<p></p>\n`,
        retroCredit: `<p></p>\n`,
        nutritionCalculatorBuilderDisclaimer: `<p></p>\n`,
        chooseYourOwnBirthday: `<p></p>\n`
      };
    }
  }

  getJoinRewards(): string | undefined {
    return this.config.cms.joinRewards?.emailUpdates;
  }

  async setJoinRewards() {
    const cfData = await this.getGraphqlContentFragment('join-rewards');

    if (cfData && cfData.joinRewardsList && cfData.joinRewardsList.items[0]) {
      let csJoinRewards = cfData.joinRewardsList.items[0];

      this.config.cms.joinRewards = {
        header: csJoinRewards.header,
        buttonShortText: csJoinRewards.buttonShortText,
        buttonLongText: csJoinRewards.buttonLongText,
        emailUpdates: csJoinRewards.emailUpdates.html,
      };
    }
    else {
      this.logger.error(`Missing content fragment: join-rewards`);

      this.config.cms.joinRewards = {
        header: 'EARN WHILE YOU EAT',
        buttonShortText: 'JOIN NOW',
        buttonLongText: 'JOIN REWARDS NOW',
        emailUpdates: `<p>You'll also get email updates which you can turn off at any time.</p>\n`,
      };
    }
  }

  getPickupOptions(): any[] {
    return this.config.cms.pickupModality?.pickupOptions ?? [];
  }

  async setPickupOptions() {
    const cfData = await this.getGraphqlContentFragment(`pickup-options`, true);

    if (cfData && cfData.pickupOptionList) {
      let options = cfData.pickupOptionList.items.map((option: any) => {
        return {
          title: option.name,
          description: option.description,
          imageUrl: option.image?._path
        }
      });

      this.config.cms.pickupModality = {
        dineInNotOpen: cfData.pickupOptionList.items[cfData.pickupOptionList.items.length - 1].name,
        pickupOptions: options
      };
    }
    else {
      this.logger.error(`Missing content fragment: pickup-options`);

      this.config.cms.pickupModality = {
        dineInNotOpen: '',
        pickupOptions: []
      };
    }
  }

  getSignInModal(): CreateAccountSignInContentFragment {
    return this.config.cms.signInModalFragment ?? { isModalEnabled: false };
  }

  async setSignInModal(): Promise<void> {
    const cfData = await this.getGraphqlContentFragment(`sign-in-modal`, true);

    if (cfData?.signInModalList?.items[0]) {
      let csSignInModal = cfData.signInModalList.items[0];

      this.config.cms.signInModalFragment = {
        isModalEnabled: true, //does not exist in cs gql fragment
        heading: csSignInModal?.heading,
        text1: csSignInModal?.text1,
        text2: csSignInModal?.text2,
        p1: 'p1@ContentType', //does not exist in cs gql fragment
        p2: 'p2@ContentType', //does not exist in cs gql fragment
        imageUrl: csSignInModal.imageUrl?._path,
      };
    }
    else {
      this.logger.error(`Missing content fragment: sign-in-modal`);

      this.config.cms.signInModalFragment = { isModalEnabled: false };
    }
  }

  getCreateAccountModal(): CreateAccountSignInContentFragment {
    return this.config.cms.createAccountFormFragment ?? { isModalEnabled: false };
  }

  async setCreateAccountModal() {
    const cfData = await this.getGraphqlContentFragment(`create-account-modal`, true);

    if (cfData && cfData.createAccountModalList && cfData.createAccountModalList.items[0]) {
      let csCreateAccountForm = cfData.createAccountModalList.items[0];

      this.config.cms.createAccountFormFragment = {
        isModalEnabled: true, //does not exist in cs gql fragment
        heading: csCreateAccountForm?.heading,
        subheading: csCreateAccountForm?.subheading,
        p1: 'p1@ContentType', //does not exist in cs gql fragment
        p2: 'p2@ContentType', //does not exist in cs gql fragment
        text1: csCreateAccountForm?.text1,
        text2: csCreateAccountForm?.text2,
        phoneDisclaimer: csCreateAccountForm?.mobileNumberDisclaimer?.html,
        buttonText: csCreateAccountForm?.buttonText,
        imageUrl: csCreateAccountForm.imageUrl?._path,
      };
    }
    else {
      this.logger.error(`Missing content fragment: create-account-modal`);

      this.config.cms.createAccountFormFragment = { isModalEnabled: false };
    }
  }

  getAccountOptInToolTips(): AccountOptInToolTipsContentFragment {
    return this.config.cms.accountOptInToolTipsFragment || {};
  }

  async setAccountOptInToolTips() {
    this.config.cms.accountOptInToolTipsFragment = {};

    const cfRewardsData = await this.getGraphqlContentFragment(`account-opt-in-tool-tips;variation=rewards;tag=content-fragments`, true);
    if (cfRewardsData && cfRewardsData.accountOptInToolTipsList && cfRewardsData.accountOptInToolTipsList.items[0]) {
      let rewards = cfRewardsData.accountOptInToolTipsList.items[0];
      this.config.cms.accountOptInToolTipsFragment.rewardsTitle = rewards.title;
      this.config.cms.accountOptInToolTipsFragment.rewardsBodyText = rewards.bodyText?.html;
    }
    else {
      this.logger.error(`Missing content fragment: account-opt-in-tool-tips for rewards`);
    }

    const cfEmailData = await this.getGraphqlContentFragment(`account-opt-in-tool-tips;variation=email;tag=content-fragments`, true);
    if (cfEmailData && cfEmailData.accountOptInToolTipsList && cfEmailData.accountOptInToolTipsList.items[0]) {
      let emails = cfEmailData.accountOptInToolTipsList.items[0];
      this.config.cms.accountOptInToolTipsFragment.emailTitle = emails.title;
      this.config.cms.accountOptInToolTipsFragment.emailBodyText = emails.bodyText?.html;
    }
    else {
      this.logger.error(`Missing content fragment: account-opt-in-tool-tips for email`);
    }

    const cfSmsData = await this.getGraphqlContentFragment(`account-opt-in-tool-tips;variation=sms;tag=content-fragments`, true);
    if (cfSmsData && cfSmsData.accountOptInToolTipsList && cfSmsData.accountOptInToolTipsList.items[0]) {
      let sms = cfSmsData.accountOptInToolTipsList.items[0];
      this.config.cms.accountOptInToolTipsFragment.smsTitle = sms.title;
      this.config.cms.accountOptInToolTipsFragment.smsBodyText = sms.bodyText?.html;
    }
    else {
      this.logger.error(`Missing content fragment: account-opt-in-tool-tips for email`);
    }
  }

  getFacModalContent(): FacModalContent | undefined {
    return this.config.cms.facModalContent;
  }

  async setFacModalContent() {
    const facData = await this.getGraphqlContentFragment('fac', true);

    if (facData?.facList && facData.facList?.items[0]) {
      let fac = facData.facList.items[0];

      this.config.cms.facModalContent = {
        header: fac.facHeadline,
        pickupToggleIconUrl: fac.pickupToggleIcon?._path,
        pickupText: fac.pickupSearchBarText,
        deliveryToggleIconUrl: fac.deliveryToggleIcon?._path,
        deliveryText: fac.deliveryToggleText,
        pickupSearchBar: fac.pickupSearchBarText,
        favoriteHeader: fac.favoriteHeader,
        favoriteBody: fac.favoriteBodyWeb
      };
    }
    else {
      this.logger.error(`Missing content fragment: fac`);

      this.config.cms.facModalContent = {
        header: 'Find a Chipotle for Pickup',
        pickupToggleIconUrl: '',
        pickupText: '',
        deliveryToggleIconUrl: '',
        deliveryText: '',
        pickupSearchBar: '',
        favoriteHeader: 'Favorites',
        favoriteBody: 'Add any restaurant to your favorites for super fast ordering'
      };
    }
  }

  getBagContent(): BagContent | undefined {
    return this.config.cms.bagContent;
  }

  async setBagContent() {
    const bagData = await this.getGraphqlContentFragment('bag', true);

    if (bagData?.bagList && bagData.bagList.items[0]) {
      let bag = bagData.bagList?.items[0];

      this.config.cms.bagContent = {
        multiplePromosAvailable: bag.multiplePromosAvailable,
        promoCodeText: bag.promoCodeText,
        promoAddedToEmptyBag: bag.promoAddedToEmptyBag,
        rewardsAvailableText: bag.moreThan1Offer,
        emptyBagImageUrl: bag.emptyBagImage?._path,
        viewPromoModal: bag.viewPromoModal,
        viewPromoModalDisclaimer: bag.viewPromoModalDisclaimer
      };
    }
    else {
      this.logger.error(`Missing content fragment: bag`);

      this.config.cms.bagContent = {
        multiplePromosAvailable: 'REWARDS AVAILABLE',
        promoCodeText: 'Enter a Promo Code',
        promoAddedToEmptyBag: 'REWARD ADDED',
        rewardsAvailableText: '',
        emptyBagImageUrl: '',
        viewPromoModal: 'REWARDS',
        viewPromoModalDisclaimer: 'Limit one reward per order.'
      };
    }
  }

  getNutritionFacts(): NutritionFactsContentFragment | undefined {
    return this.config.cms.nutritionFactsFragment
  }

  async setNutritionFacts() {
    const nutritionData = await this.getGraphqlContentFragment('nutrition-facts', true);

    if (nutritionData?.nutritionFactsList && nutritionData.nutritionFactsList.items[0]) {
      let nutritionFactsInfo = nutritionData.nutritionFactsList.items[0];

      this.config.cms.nutritionFactsFragment = {
        label: nutritionFactsInfo.nutritionFactsCTALabel,
        path: nutritionFactsInfo.nutritionFactsSheetReference?._path,
      };
    }
    else {
      this.logger.error(`Missing content fragment: nutrition-facts`);
    }
  }

  //for use when we incorporate more regions (ie uk, fr, de, etc)
  getRegion(): string {
    const region = this.store.state.ui.countryProfile.countryCode;
    switch (region) {
      case 'US':
        return 'en-us';
      case 'CA':
        return 'en-ca'
      case 'GB':
        return 'en-gb';
      case 'DE':
        return 'de-de'
      case 'FR':
        return 'fr-fr';
      default:
        return 'en-us';
    }
  }

  getAccountModal(): AccountModalContentFragment {
    return this.config.cms.accountModalFragment ?? {};
  }

  async setAccountModal() {
    const cfData = await this.getGraphqlContentFragment(`account-modal`, true);

    if (cfData && cfData.accountModalList && cfData.accountModalList.items[0]) {
      let csAccountModal = cfData.accountModalList.items[0];

      this.config.cms.accountModalFragment = {
        linkForFavoriteRecentOrders: csAccountModal?.linkForFavoriteRecentOrders,
        guestAccountCreationHeadline: csAccountModal?.guestAccountCreationHeadline
      };
    }
    else {
      this.logger.error(`Missing content fragment: account-modal`);

      this.config.cms.accountModalFragment = {};
    }
  }

  getTaxContent(): TaxContent | undefined {
    return this.config.cms.taxContent;
  }

  async setTaxContent() {
    const taxData = await this.getGraphqlContentFragment('tax', true);

    if (taxData && taxData.taxList && taxData.taxList.items[0]) {
      let tax = taxData.taxList.items[0];

      this.config.cms.taxContent = {
        itemizedTaxLine: tax.itemizedTaxLine,
        vatRate: tax.vatRate,
        registrationNumberText: tax.registrationNumberText,
        registrationNumber: tax.registrationNumber
      };
    }
    else {
      this.logger.error(`Missing content fragment: tax`);

      this.config.cms.taxContent = {
        itemizedTaxLine: 'Tax',
        vatRate: '',
        registrationNumberText: '',
        registrationNumber: ''
      };
    }
  }

  getGuestOrderConfirmation(): OrderConfirmationCreateAccountExperience | null {
    return this.config.cms.orderConfirmationCreateAccountExperience;
  }

  async setGuestOrderConfirmation() {
    const cfData = await this.getGraphqlContentFragment(`guest-order-confirmation`, true);

    if (cfData?.guestOrderConfirmationList?.items[0]) {
      let csGuestOrderConfirmation = cfData.guestOrderConfirmationList.items[0];

      this.config.cms.orderConfirmationCreateAccountExperience = {
        header: csGuestOrderConfirmation.headerText.html,
        description: csGuestOrderConfirmation.subTextDescription.html,
        medallionImageUrl: csGuestOrderConfirmation.medallionImage._path
      };
    }
    else {
      this.logger.error(`Missing content fragment: guest-order-confirmation`);
      this.config.cms.orderConfirmationCreateAccountExperience = {
        header: '<p>CREATE AN ACCOUNT TO GET POINTS FOR THIS ORDER...</p>\n',
        description: '',
        medallionImageUrl: '/content/dam/chipotle/icons-and-animations/chipotle-pepper-icon/pepper-medallion.svg'
      };
    }
  }

  getOrderReviewModal(): OrderReviewModalContentFragment | undefined {
    return this.config.cms.orderReviewModal;
  }

  async setOrderReviewModal() {
    const cfData = await this.getGraphqlContentFragment('order-review-modal', true);

    if (cfData?.orderReviewModalList?.items[0]) {
      let orderReviewModalInfo = cfData.orderReviewModalList.items[0];
      
      this.config.cms.orderReviewModal = {
        title: orderReviewModalInfo.title.html,
        primaryCta: orderReviewModalInfo.primaryCta,
        secondaryCta: orderReviewModalInfo.secondaryCta,
        countdownTimer: orderReviewModalInfo.countdownTimer
      };
    }
    else {
      this.logger.error(`Missing content fragment: order-review-modal`);
      this.config.cms.orderReviewModal = {
        title: "<p>Hang Tight,<br>We're Confirming<br>Your Order...</p>",
        primaryCta: 'Looks Good',
        secondaryCta: 'Cancel',
        countdownTimer: 10
      };
    }
  }

  getCyobRewardCard(): CyobRewardContentFragment {
    return this.config.cms.cyobRewardCard || {};
  }

  async setCyobRewardCard() {
    this.config.cms.cyobRewardCard = {}

    const cfData = await this.getGraphqlContentFragment(`choose-your-own-birthday`, true);
    if (cfData && cfData.chooseYourOwnBirthdayList && cfData.chooseYourOwnBirthdayList.items[0]) {
      let chooseYourOwnBirthdayList = cfData.chooseYourOwnBirthdayList.items[0];
      this.config.cms.cyobRewardCard = {
        title: chooseYourOwnBirthdayList.title,
        subtitle: chooseYourOwnBirthdayList.subtitle,
      }
    } else {
      this.logger.error(`Missing content fragment: choose-your-own-birthday`);
    }
  }

  getReferAFriendFooter(): ReferAFriendFooterContentFragment {
    return this.config.cms.referAFriendFooter || {};
  }

  async setReferAFriendFooter() {
    this.config.cms.referAFriendFooter = {};

    const cfData = await this.getGraphqlContentFragment(`refer-a-friend`, true);
    
    if (cfData && cfData.referAFriendList && cfData.referAFriendList.items[0]) {
      const referAFriend = cfData.referAFriendList.items[0];
      this.config.cms.referAFriendFooter = {
        title: referAFriend.title,
        body: referAFriend.body,
        ctaButton: referAFriend.ctaButton
      };
    } else {
      this.logger.error(`Missing content fragment: refer-a-friend`);
    }
  }

  getReferAFriendModal(): ReferAFriendModalContentFragment {
    return this.config.cms.referAFriendModal || {};
  }

  async setReferAFriendModal() {
    this.config.cms.referAFriendModal = {};

    const cfData = await this.getGraphqlContentFragment(`refer-a-friend-modal`, true);
    
    if (cfData && cfData.referAFriendModalList && cfData.referAFriendModalList.items[0]) {
      const referAFriendModal = cfData.referAFriendModalList.items[0];
      this.config.cms.referAFriendModal = {
        title: referAFriendModal.title,
        subtitle: referAFriendModal.subtitle?.html,
        primaryCta: referAFriendModal.primaryCta,
        termsAndConditionsSubheader: referAFriendModal.termsConditionsSubheader,
        termsAndConditionsBody: referAFriendModal.termsConditionsBodyText?.html
      };
    } else {
      this.logger.error(`Missing content fragment: refer-a-friend-modal`);
    }
  }

  getAlreadyAMemberModal(): AlreadyAMemberModalContentFragment {
    return this.config.cms.alreadyAMemberModal || {};
  }

  async setAlreadyAMemberModal() {
    this.config.cms.alreadyAMemberModal = {};

    const cfData = await this.getGraphqlContentFragment(`you're-already-a-member`, true);
    if (cfData && cfData.you_reAlreadyAMemberList && cfData.you_reAlreadyAMemberList.items[0]) {
      const alreadyAMemberModal = cfData.you_reAlreadyAMemberList.items[0];
      this.config.cms.alreadyAMemberModal = {
        title: alreadyAMemberModal.title?.html,
        subtitle: alreadyAMemberModal.subtitle?.html,
        bodyText1: alreadyAMemberModal.bodyText1?.html,
        imageUrl1: alreadyAMemberModal.image1?._path,
        bodyText2: alreadyAMemberModal.bodyText2?.html,
        imageUrl2: alreadyAMemberModal.image2?._path,
        bodyText3: alreadyAMemberModal.bodyText3?.html,
        imageUrl3: alreadyAMemberModal.image3?._path,
        primaryCta: alreadyAMemberModal.primaryCta,
        secondaryCta: alreadyAMemberModal.secondaryCta
      };
    } else {
      this.logger.error(`Missing content fragment: you're-already-a-member`);
    }
  }

  getYoureInvitedModal(): YoureInvitedModalContentFragment {
    return this.config.cms.youreInvitedModal || {};
  }

  async setYoureInvitedModal() {
    this.config.cms.youreInvitedModal = {};

    const cfData = await this.getGraphqlContentFragment(`refer-a-friend-link-opened`, true);

    if (cfData && cfData.referAFriendLinkOpenedList && cfData.referAFriendLinkOpenedList.items[0]) {
      const youreInvitedModal = cfData.referAFriendLinkOpenedList.items[0];
      this.config.cms.youreInvitedModal = {
        title: youreInvitedModal.title,
        subtitle: youreInvitedModal.subtitle?.html,
        legalCopy: youreInvitedModal.legalCopy?.html
      };
    }
  }

  getReferralJoinSuccessModal(): ReferralJoinSuccessContentFragment {
    return this.config.cms.referralJoinSuccessModal || {};
  }

  async setReferralJoinSuccessModal() {
    this.config.cms.referralJoinSuccessModal = {};

    const cfData = await this.getGraphqlContentFragment(`account-created`, true);

    if (cfData && cfData.accountCreatedList && cfData.accountCreatedList.items[0]) {
      const accountCreated = cfData.accountCreatedList.items[0];
      this.config.cms.referralJoinSuccessModal = {
        title: accountCreated.title,
        subtitle: accountCreated.subtitle,
        bodyText: accountCreated.bodyText.html,
        primaryCta: accountCreated.primaryCta
      };
    } else {
      this.logger.error(`Missing content fragment: account-created`);
    }
  }

  getReferralNotEligibleModal(): ReferralNotEligibleContentFragment {
    return this.config.cms.referralNotEligibleModal || {};
  }

  async setReferralNotEligibleModal() {
    this.config.cms.referralNotEligibleModal = {};

    const cfData = await this.getGraphqlContentFragment(`referral-program-ineligible-modal`, true);
    if (cfData && cfData.referralProgramIneligibleModalList && cfData.referralProgramIneligibleModalList.items[0]) {
      const referralProgramIneligibleModal = cfData.referralProgramIneligibleModalList.items[0];
      this.config.cms.referralNotEligibleModal = {
        title: referralProgramIneligibleModal.headline,
        subtitle: referralProgramIneligibleModal.subHeadline,
        description: referralProgramIneligibleModal.bodyText?.html,
        legalCopy: referralProgramIneligibleModal.legalText?.html
      };
    } else {
      this.logger.error(`Missing content fragment: referral-program-ineligible-modal`);
    }
  }

  getReferAFriendLinkOpened(): ReferAFriendLinkOpenedContentFragment {
    return this.config.cms.referAFriendLinkOpened || {};
  }

  async setReferAFriendLinkOpened() {
    this.config.cms.referAFriendLinkOpened = {};

    const cfData = await this.getGraphqlContentFragment(`refer-a-friend-link-opened`, true);

    if (cfData && cfData.referAFriendLinkOpenedList && cfData.referAFriendLinkOpenedList.items[0]) {
      const referAFriendLinkOpened = cfData.referAFriendLinkOpenedList.items[0];
      this.config.cms.referAFriendLinkOpened = {
        title: referAFriendLinkOpened.title,
        subtitle: referAFriendLinkOpened.subtitle?.html,
        legalCopy: referAFriendLinkOpened.legalCopy?.html
      };
    } else {
      this.logger.error(`Missing content fragment: refer-a-friend-link-opened`);
    }
  }

  getEnergyUnitByCountry(): string {
    if (this.store.state.ui.countryProfile.countryCode === 'GB') {
      return 'kcal';
    }
    return 'cal'
  }

  getSystemFlags() {
    return this.config.cms.systemFlags;
  }

  getHeaderPages() {
    return this.config.cms.systemFlags.headerPages;
  }

  getGuacMode(): GuacMode | null {
    return (this.store.state.featureFlags.orderingStatus?.isGuacModeActive && this.config.cms.guacMode) || null;
  }

  getPayeezyJsUrl(): string {
    return this.config.payeezy.jsLibrary;
  }

  getChaseBaseUrl(): string {
    return this.config.chase.baseFormUrl;
  }

  getChaseJsUrl(): string {
    return this.config.chase.jsLibraryUrl;
  }

  getChaseUkBaseUrl(): string {
    return this.config.chaseuk.baseFormUrl;
  }

  getChaseUkRedirectUrl(): string {
    return this.config.chaseuk.redirectUrl;
  }

  getUComIsDebugConfiguration(): boolean {
    return this.config.ucom.isDebugConfiguration;
  }

  getSessionFrameUrl(): string {
    return this.config.urls.sessionFrameUrl;
  }

  getAmeliaPepperJsUrl(): string {
    return this.config.pepper.jsLibraryUrl;
  }

  getAmeliaPepperCssUrl(): string {
    return this.config.pepper.cssLibraryUrl;
  }

  getRealFoodprintUrl(): string {
    return this.config.urls.realFoodprint;
  }

  getHowGoodUrl(): string {
    return this.config.urls.howGood;
  }

  getRewardsPath(): string {
    return this.config.urls.rewardsPath;
  }

  getTwitterAchievementBaseUrl(): string {
    return this.config.urls.twitterAchievementBaseUrl;
  }

  getAllergenStatementUrl(): string {
    return this.config.urls.allergenStatementUrl;
  }

  getRefreshPointsThrottleTimeInMinutes(): number {
    return this.config.services.refreshPointsThrottleTimeInMinutes ?? 0;
  }

  getIsStubPayment(): boolean {
    return this.config.isStubPayment;
  }

  getApplePayMerchantId(): string {
    const countryCode = this.store.state.ui.countryProfile.countryCode;

    switch (countryCode) {
      case CountryCode.US:
        return this.config.applePay.merchantIdUcom;
      case CountryCode.CA:
        return this.config.applePay.merchantIdChaseCanada;
      default:
        return '';
    }
  }

  getGooglePayMerchantGatewayId(): string {
    const countryCode = this.store.state.ui.countryProfile.countryCode;
    switch (countryCode) {
      case CountryCode.US:
        return this.config.googlePay.merchantGatewayIdUcom;
      case CountryCode.CA:
        return this.config.googlePay.merchantGatewayIdChaseCanada;
      default:
        return '';
    }
  }

  getGooglePayMerchantGateway(): string {
    const countryCode = this.store.state.ui.countryProfile.countryCode;
    switch (countryCode) {
      case CountryCode.US:
        return this.config.googlePay.merchantGateway;
      case CountryCode.CA:
        return this.config.googlePay.merchantGatewayCanada;
      default:
        return '';
    }
  }

  getGooglePayMerchantId(): string {
    return this.config.googlePay.merchantId;
  }

  getGooglePayEnvironment(): google.payments.api.Environment {
    return this.config.googlePay.environment as google.payments.api.Environment;
  }

  getStubPayment(): SubmitOrderRequestPaymentMethod {
    const isCASite = this.store.state.ui.countryProfile.countryCode === CountryCode.CA;
    const payment: SubmitOrderRequestPaymentMethod = {
      cardHolderName: this.config.stubPaymentInformation.cardHolderName,
      creditCardExpiration: this.config.stubPaymentInformation.creditCardExpiration,
      creditCardSingleUseToken: this.config.stubPaymentInformation.creditCardSingleUseToken,
      creditCardType: this.config.stubPaymentInformation.creditCardType,
      creditCardZipCode: this.config.stubPaymentInformation.creditCardZipCode,
      lastFourAccountNumbers: this.config.stubPaymentInformation.lastFourAccountNumbers,
      paymentProviderId: !isCASite ? this.config.stubPaymentInformation.paymentProviderId : this.config.stubPaymentInformation.paymentProviderId_CA,
      paymentType: SubmitOrderRequestPaymentMethodType[this.config.stubPaymentInformation.paymentType as keyof typeof SubmitOrderRequestPaymentMethodType]
    };

    if (!isNaN(this.config.stubPaymentInformation.chipotleWalletId as number)) {
      payment.chipotleWalletId = this.config.stubPaymentInformation.chipotleWalletId;
    }

    return payment;
  }

  getOptinProgramLaunchDate(): Date {
    return new Date(Date.parse(this.config.optinProgramLaunchDate));
  }

  showRestaurantsWithNoAddress(): boolean {
    return this.config.google.showRestaurantsWithNoAddress;
  }

  async getGraphqlContentFragment(contentFragment: string, useRegion: boolean = false): Promise<any | null> {
    const countryProfile = getCountryByHostname(window.location.hostname);
    const isAemQualified = location.hostname.toLowerCase().startsWith('www');
    const originUrl = location.origin;

    let aemBaseUrl = '';
    let region = '';
    switch (countryProfile.countryCode) {
      case 'CA':
        aemBaseUrl = isAemQualified ? originUrl : 'https://chipotle.ca';
        region = 'en-ca';
        break;
      case 'GB':
        aemBaseUrl = isAemQualified ? originUrl : 'https://chipotle.co.uk';
        region = 'en-gb';
        break;
      default:
        aemBaseUrl = isAemQualified ? originUrl : 'https://chipotle.com';
        region = 'en-us';
        break;
    }
    // For local dev, use same-origin requests and let vue-dev-server proxy handle the upstream host.
    if(isLocal()){
      aemBaseUrl = originUrl;
    }

    const contentFragmentUrl = useRegion ? `${aemBaseUrl}/graphql/execute.json/chipotle/${contentFragment};region=${region};` : `${aemBaseUrl}/graphql/execute.json/chipotle/${contentFragment}`;
    const contentFragmentData = (await this.httpClient({ url: contentFragmentUrl })).data;

    if (!contentFragmentData.data) {
      this.logger.error(`Undefined content fragment: ${contentFragment}`);
      return null;
    }

    return contentFragmentData.data;
  }

  getIdMeClientId(): string {
    return this.config.idMe.clientId;
  }

  getIdMeRedirectUrl(): string {
    return this.config.idMe.redirectUrl;
  }

  getIdMeWidgetScriptUrl(): string {
    return this.config.idMe.widgetScriptUrl;
  }

  getSummerOfExtrasIntroScreens(): SummerOfExtrasIntroScreensContentFragment | undefined {
    return this.config.cms.summerOfExtrasIntroScreens;
  }

  async setSummerOfExtrasIntroScreens() {
    const cfData = await this.getGraphqlContentFragment('summer-of-extras-intro-screens', true);

    if (cfData?.summerOfExtrasIntroScreensList?.items[0]) {
      let introScreens = cfData.summerOfExtrasIntroScreensList.items[0];

      this.config.cms.summerOfExtrasIntroScreens = {
        title: introScreens.title?.html,
        bodySlide1: introScreens.bodySlide1?.html,
        description1: introScreens.description1?.html,
        description2: introScreens.description2?.html,
        description3: introScreens.description3?.html,
        bodySlide3: introScreens.bodySlide3?.html,
      };
    }
    else {
      this.logger.error(`Missing content fragment: summer-of-extras-intro-screens`);

      this.config.cms.summerOfExtrasIntroScreens = {
        title: '',
        description1: '',
        description2: '',
        description3: '',
        bodySlide3: '',
      };
    }
  }
  
  getScanlessIntroductionModal(): ScanlessIntroductionContentFragment {
    return this.config.cms.scanlessIntroductionFragment ?? { isModalEnabled: false };
  }

  async setScanlessIntroductionModal(): Promise<void> {
    const cfData = await this.getGraphqlContentFragment('scanless-introduction', true);
    const scanlessContent = cfData?.scanlessIntroductionList?.items?.[0] || cfData?.scanlessIntroduction?.items?.[0] || null;
    const imageField = scanlessContent?.imageUrl;
    const imagePath = typeof imageField === 'string' ? imageField : imageField?._path;
    const imageUrl = imagePath || '';

    if (scanlessContent) {
      this.config.cms.scanlessIntroductionFragment = {
        isModalEnabled: true,
        heading: scanlessContent?.heading || scanlessContent?.title,
        bodyHtml: scanlessContent?.bodyHtml?.html
          || scanlessContent?.body?.html
          || scanlessContent?.description?.html
          || scanlessContent?.text1
          || '',
        footerHtml: scanlessContent?.footer?.html || '',
        imageUrl,
      };
    }
    else {
      this.logger.error('Missing content fragment: scanless-introduction');
      this.config.cms.scanlessIntroductionFragment = { isModalEnabled: false };
    }
  }

  getScanlessInfoIconModal(): ScanlessIntroductionContentFragment {
    return this.config.cms.scanlessInfoIconFragment ?? { isModalEnabled: false };
  }

  async setScanlessInfoIconModal(): Promise<void> {
    const cfData = await this.getGraphqlContentFragment('scanless-info-icon;region=en-us');
    const infoIconContent = cfData?.scanlessInfoIconList?.items?.[0] || cfData?.scanlessInfoIcon?.items?.[0] || null;

    if (infoIconContent) {
      this.config.cms.scanlessInfoIconFragment = {
        isModalEnabled: true,
        heading: infoIconContent?.heading || infoIconContent?.title,
        bodyHtml: infoIconContent?.bodyHtml?.html
          || infoIconContent?.body?.html
          || infoIconContent?.description?.html
          || infoIconContent?.text1
          || '',
        footerHtml: infoIconContent?.footer?.html || '',
      };
    }
    else {
      this.logger.error('Missing content fragment: scanless-info-icon;region=en-us');
      this.config.cms.scanlessInfoIconFragment = { isModalEnabled: false };
    }
  }

  getScanlessCreditCardAlreadyAssociated(): ScanlessCreditCardAlreadyAssociatedContentFragment | undefined {
    return this.config.cms.scanlessCreditCardAlreadyAssociated;
  }

  async setScanlessCreditCardAlreadyAssociated(): Promise<void> {
    const cfData = await this.getGraphqlContentFragment('scanless-credit-card-already-associated', true);

    if (cfData?.scanlessCreditCardAlreadyAssociatedList?.items[0]) {
      let cardAlreadyAssociated = cfData.scanlessCreditCardAlreadyAssociatedList.items[0]

      this.config.cms.scanlessCreditCardAlreadyAssociated = {
        isModalEnabled: true,
        title: cardAlreadyAssociated.title,
        body: cardAlreadyAssociated.body.html
      }
    }
    else {
      this.logger.error('Missing content fragment: scanless-credit-card-already-associated');
      this.config.cms.scanlessCreditCardAlreadyAssociated = { isModalEnabled: false };
    }
  }
  
  getChipotleuReVerification(): ChipotleuReVerificationContentFragment {
    return this.config.cms.chipotleuReVerification || {};
  }

  async setChipotleuReVerification() {
    this.config.cms.chipotleuReVerification = {};

    const cfData = await this.getGraphqlContentFragment('chipotleu-re-verification', true);

    if (cfData && cfData.chipotleuReVerificationList && cfData.chipotleuReVerificationList.items[0]) {
      const item = cfData.chipotleuReVerificationList.items[0];
      this.config.cms.chipotleuReVerification = {
        subheadline: item.subheadline,
        headline: item.headline,
        body: item.body?.html,
        ctaText: item.ctaText,
      };
    } else {
      this.logger.error(`Missing content fragment: chipotleu-re-verification`);
    }
  }

  getChipotleuReVerificationSuccessModal(): ChipotleuReVerificationSuccessModalContentFragment | undefined {
    return this.config.cms.chipotleuReVerificationSuccessModal || {};
  }

  async setChipotleuReVerificationSuccessModal() {
    this.config.cms.chipotleuReVerificationSuccessModal = {};

    const cfData = await this.getGraphqlContentFragment('chipotleu-re-verification-success-modal', true);

    if (cfData && cfData.chipotleuReVerificationSuccessModalList && cfData.chipotleuReVerificationSuccessModalList.items[0]) {
      const item = cfData.chipotleuReVerificationSuccessModalList.items[0];
      this.config.cms.chipotleuReVerificationSuccessModal = {
        headline: item.headline,
        ctaText: item.ctaText,
        image: item.image?._path,
        body: item.body?.html,
      };
    } else {
      this.logger.error(`Missing content fragment: chipotleu-re-verification-success-modal`);
    }
  }

  getEmployeeRewardsHowItWorksModal(): EmployeeRewardsHowItWorksModalContentFragment | undefined {
    return this.config.cms.employeeRewardsHowItWorksModal;
  }

  async setEmployeeRewardsHowItWorksModal() {
    const cfData = await this.getGraphqlContentFragment('employee-rewards-how-it-works-modal', true);

    if (cfData?.employeeRewardsHowItWorksModalList.items[0]) {
      let howItWorksModal = cfData.employeeRewardsHowItWorksModalList.items[0];

      this.config.cms.employeeRewardsHowItWorksModal = {
        headline: howItWorksModal.headline,
        subHeadline: howItWorksModal.subHeadline,
        bodyText: howItWorksModal.bodyText?.html,
      }
    } else {
      this.logger.error(`Missing content fragment: employee-rewards-how-it-works`);

      this.config.cms.employeeRewardsHowItWorksModal = {
        headline: "HOW IT WORKS",
        subHeadline: "Chipotle Employee Rewards",
        bodyText: "<p>As a Chipotle team member, you earn an extra 25% on top of your rewards.</p><p></p><p>Earn 12.5 points for every $1 you spend at Chipotle.*</p><p>*Excludes alcohol, and tax, fees, &amp; tips.</p><p></p><p>Choose from a variety of rewards in the Rewards Exchange, from burritos and guac to donations and apparel.</p><p></p><p>Pick a favorite reward and we'll help you track your points towards it.</p>",
      };
    }
  }
}
